var DividerLook;
(function (DividerLook) {
    DividerLook["PRIMARY"] = "primary";
    DividerLook["SECONDARY"] = "secondary";
})(DividerLook || (DividerLook = {}));
export { DividerLook };
//# sourceMappingURL=Divider.types.js.map